import {
  DefaultButton,
  NormalPeoplePicker,
  Panel,
  PanelType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PeoplePickerPanel = ({
  onClick,
  onClose,
  isOpen,
  userItems,
  currentUserId,
  showSpinner,
  headerText,
  guideText,
  selectMultiple,
  selectedItems,
  allowEmptyOnClick,
}) => {
  const { t: translator } = useTranslation();

  const [selectedItemsLocal, setSelectedItems] = useState([]);

  useEffect(() => {
    setSelectedItems(selectedItems || []);
  }, [isOpen, selectedItems]);

  const onResolveSuggestions = (filter) => {
    filter = filter || '';
    return userItems.filter(
      (user) =>
        !!user?.text &&
        user.key !== currentUserId &&
        !selectedItemsLocal.some((item) => item.key === user.key) &&
        user.text.toLowerCase().includes(filter.toLowerCase()),
    );
  };

  const onEmptyResolveSuggestions = () => onResolveSuggestions();

  const onItemsChange = (items) => {
    setSelectedItems(items);
  };

  const onPrimaryButtonClick = () => {
    if (selectMultiple) {
      onClick(selectedItemsLocal);
    } else {
      const [selectedItem] = selectedItemsLocal;
      selectedItem && onClick(selectedItem.key);
    }
  };

  return (
    <div>
      <Panel
        isOpen={isOpen}
        onDismiss={onClose}
        onOuterClick={(_) => null}
        isLightDismiss={true}
        type={PanelType.medium}
        headerText={headerText}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <div className="panel-content">
            <p style={{ fontWeight: 500, fontSize: 16 }}>{guideText}</p>
            <NormalPeoplePicker
              onEmptyResolveSuggestions={onEmptyResolveSuggestions}
              onResolveSuggestions={onResolveSuggestions}
              itemLimit={selectMultiple ? undefined : 1}
              pickerSuggestionsProps={getSuggestionProps(translator)}
              key={'people-picker'}
              selectedItems={selectedItemsLocal}
              onChange={onItemsChange}
              removeButtonAriaLabel={translator(
                'ariaLabel.peoplePickerRemoveButton',
              )}
              selectionAriaLabel={translator('ariaLabel.peoplePickerSelection')}
              ariaLabel={translator('ariaLabel.peoplePicker')}
            />
          </div>
          <div className="panel-buttons">
            {showSpinner && <Spinner size={SpinnerSize.large} />}
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onClose}
              disabled={showSpinner}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              disabled={
                showSpinner ||
                (!selectedItemsLocal.length && !allowEmptyOnClick)
              }
              onClick={onPrimaryButtonClick}
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

const getSuggestionProps = (translator) => ({
  suggestionsHeaderText: translator('components.peoplePicker.suggestedPeople'),
  noResultsFoundText: translator('components.peoplePicker.noResults'),
  loadingText: translator('components.peoplePicker.loadingData'),
  showRemoveButtons: false,
  'aria-label': translator('ariaLabel.peoplePickerSuggestion'),
  suggestionsContainerAriaLabel: translator(
    'ariaLabel.peoplePickerSuggestionsContainer',
  ),
});

export { PeoplePickerPanel };
